var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "root",
      staticClass: "epg2",
      class: {
        "epg2--preview": _vm.previewActive,
        "epg2--zone-list": _vm.showInfo && _vm.infoZone === "list"
      },
      style: _vm.themeStyles
    },
    [
      _c(
        "div",
        { staticClass: "epg2__head" },
        [
          _c(
            "BackButton",
            {
              staticClass: "epg2__back",
              attrs: { "is-active": _vm.isBackFocused },
              on: { click: _vm.leave }
            },
            [_vm._v("\n      " + _vm._s(_vm.getBack) + "\n    ")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "epg2__title" }, [
            _vm._v(_vm._s(_vm.getTitle))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "epg2__clock" }, [
            _vm._v(_vm._s(_vm.clockLabel))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "epg2__status" }, [
            _vm.isLoading
              ? _c("span", [
                  _vm._v(
                    _vm._s(_vm.getLoading) +
                      " " +
                      _vm._s(_vm.progress.loaded) +
                      "/" +
                      _vm._s(_vm.progress.total)
                  )
                ])
              : _vm.error
              ? _c("span", { staticClass: "epg2__error" }, [
                  _vm._v(_vm._s(_vm.error))
                ])
              : _c("span", [_vm._v(_vm._s(_vm.viewRangeLabel))])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "epg2__axis" }, [
        _c("div", { staticClass: "epg2__axis-spacer" }, [
          _vm._v(_vm._s(_vm.dayLabel))
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "epg2__axis-lane" },
          [
            _vm._l(_vm.slots, function(slot) {
              return _c(
                "div",
                {
                  key: slot.at,
                  staticClass: "epg2__axis-slot",
                  style: {
                    left: slot.offsetPercent + "%",
                    width: slot.widthPercent + "%"
                  }
                },
                [_vm._v(_vm._s(slot.label))]
              )
            }),
            _vm._v(" "),
            _vm.nowPercent !== null
              ? _c("div", {
                  staticClass: "epg2__now",
                  style: { left: _vm.nowPercent + "%" }
                })
              : _vm._e()
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "epg2__rows" },
        [
          _vm._l(_vm.visibleRows, function(row) {
            return _c(
              "div",
              {
                key: row.channel._id || row.channel.id || row.channel.position,
                staticClass: "epg2__row",
                class: {
                  "epg2__row--focus": row.index === _vm.focusChannelIndex
                }
              },
              [
                _c("div", { staticClass: "epg2__channel" }, [
                  _c("div", { staticClass: "epg2__channel-pos" }, [
                    _vm._v(_vm._s(row.channel.position))
                  ]),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "epg2__channel-logo",
                    attrs: { src: row.logo, alt: row.channel.name },
                    on: { error: _vm.onLogoError }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "epg2__channel-name" }, [
                    _vm._v(_vm._s(row.channel.name))
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "epg2__lane" },
                  [
                    _vm._l(row.programs, function(item) {
                      return _c(
                        "div",
                        {
                          key: item.program.id,
                          staticClass: "epg2__program",
                          class: {
                            "epg2__program--focus":
                              row.index === _vm.focusChannelIndex &&
                              item.index === _vm.focusProgramIndex,
                            "epg2__program--running": item.progress !== null
                          },
                          style: {
                            left: item.layout.leftPercent + "%",
                            width: item.layout.widthPercent + "%"
                          }
                        },
                        [
                          _c("div", { staticClass: "epg2__program-title" }, [
                            _vm._v(_vm._s(item.program.title))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "epg2__program-time" }, [
                            _vm._v(_vm._s(item.program.start))
                          ]),
                          _vm._v(" "),
                          item.progress !== null
                            ? _c("div", {
                                staticClass: "epg2__program-progress",
                                style: { width: item.progress + "%" }
                              })
                            : _vm._e()
                        ]
                      )
                    }),
                    _vm._v(" "),
                    !row.programs.length
                      ? _c("div", { staticClass: "epg2__empty" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                row.status === "loading"
                                  ? _vm.getLoading
                                  : _vm.getNoData
                              ) +
                              "\n        "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.nowPercent !== null
                      ? _c("div", {
                          staticClass: "epg2__now epg2__now--row",
                          style: { left: _vm.nowPercent + "%" }
                        })
                      : _vm._e()
                  ],
                  2
                )
              ]
            )
          }),
          _vm._v(" "),
          _vm.rowFillerGrow > 0
            ? _c("div", {
                staticClass: "epg2__rows-filler",
                style: { flexGrow: _vm.rowFillerGrow }
              })
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "epg2__hint" }, [_vm._v(_vm._s(_vm.getHint))]),
      _vm._v(" "),
      _vm.showInfo && _vm.focusProgram
        ? _c("div", { staticClass: "epg2__info" }, [
            _c(
              "div",
              {
                staticClass: "epg2__info-box",
                class: { "epg2__info-box--active": _vm.infoZone === "text" }
              },
              [
                _c("div", { staticClass: "epg2__info-channel" }, [
                  _c("img", {
                    staticClass: "epg2__channel-logo",
                    attrs: { src: _vm.focusLogo, alt: _vm.focusChannelName },
                    on: { error: _vm.onLogoError }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.focusChannelName))])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "epg2__info-title" }, [
                  _vm._v(_vm._s(_vm.focusProgram.title))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "epg2__info-time" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.focusProgram.start) +
                      " – " +
                      _vm._s(_vm.focusProgram.end) +
                      "\n        "
                  ),
                  _vm.focusProgress !== null
                    ? _c("span", { staticClass: "epg2__info-live" }, [
                        _vm._v(_vm._s(_vm.getRunning))
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _vm.focusProgress !== null
                  ? _c("div", { staticClass: "epg2__info-progress" }, [
                      _c("div", {
                        staticClass: "epg2__info-progress-bar",
                        style: { width: _vm.focusProgress + "%" }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { ref: "infoText", staticClass: "epg2__info-text" }, [
                  _vm._v(_vm._s(_vm.focusDescription))
                ]),
                _vm._v(" "),
                _vm.infoScrollable
                  ? _c("div", { staticClass: "epg2__info-more" }, [
                      !_vm.infoAtStart ? _c("span", [_vm._v("▲")]) : _vm._e(),
                      !_vm.infoAtEnd ? _c("span", [_vm._v("▼")]) : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "epg2__info-hint" }, [
                  _vm._v(_vm._s(_vm.getInfoHint))
                ])
              ]
            ),
            _vm._v(" "),
            _vm.livePreviewEnabled
              ? _c("div", { staticClass: "epg2__preview" })
              : _vm._e(),
            _vm._v(" "),
            _vm.livePreviewEnabled
              ? _c(
                  "div",
                  { staticClass: "epg2__preview-now" },
                  [
                    _c("div", { staticClass: "epg2__preview-now-label" }, [
                      _vm._v(_vm._s(_vm.getNowOnAir))
                    ]),
                    _vm._v(" "),
                    _vm.nowProgram
                      ? [
                          _c(
                            "div",
                            { staticClass: "epg2__preview-now-title" },
                            [
                              _vm._v(
                                "\n          " + _vm._s(_vm.nowProgram.title)
                              ),
                              _vm.nowProgramDiffers
                                ? _c(
                                    "span",
                                    { staticClass: "epg2__preview-now-flag" },
                                    [_vm._v(" · " + _vm._s(_vm.getRunning))]
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "epg2__preview-now-time" }, [
                            _vm._v(
                              _vm._s(_vm.nowProgram.start) +
                                " – " +
                                _vm._s(_vm.nowProgram.end)
                            )
                          ]),
                          _vm._v(" "),
                          _vm.nowProgramProgress !== null
                            ? _c(
                                "div",
                                { staticClass: "epg2__preview-now-bar" },
                                [
                                  _c("div", {
                                    staticClass: "epg2__preview-now-bar-fill",
                                    style: {
                                      width: _vm.nowProgramProgress + "%"
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ]
                      : _c("div", { staticClass: "epg2__preview-now-time" }, [
                          _vm._v(_vm._s(_vm.getNoData))
                        ])
                  ],
                  2
                )
              : _vm._e()
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5fc015fe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fc015fe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/EPGGuide2.vue
// module id = null
// module chunks = 